import { createSelector } from 'reselect'
import { getPolicyValues } from 'quick-quote/product-whole-life/benefit-illustration/selectors'
import { getSelectedDisplayProduct } from 'quick-quote/product-selection/selectors'
import { getPensionType } from 'quick-quote/product-common/coverage-plan/selectors'
import { getPensionAge } from 'quick-quote/product-bumnan-ready/coverage-plan/selectors'

export const getPolicyValueTableBenefits = createSelector(
  getSelectedDisplayProduct,
  getPolicyValues,
  getPensionType,
  getPensionAge,
  (displayProduct, policyValue, pensionType, pensionAge) => ({
    basicPlan: displayProduct,
    policyValue,
    pensionType,
    pensionAge,
  })
)
